import { ISalonReviewsItem } from '@app/shared/models';

export const extendReviewItem = (review: ISalonReviewsItem, showPartialRatings = false): ISalonReviewsItem => {
  return {
    showPartialRatings,
    averageRating: calcAverageRating(review),
    ...review
  };
};

const calcAverageRating = (review: ISalonReviewsItem): number => (review.salonRating + review.employeesRating + review.treatmentRating) / 3;
